/**
 * Capacitor Update Adapter
 * OTA web-layer updates via @capgo/capacitor-updater (when installed)
 */

import type { UpdateAdapter, UpdateInfo } from './update.adapter';

export class CapacitorUpdateAdapter implements UpdateAdapter {
  // Capgo OTA updates — requires @capgo/capacitor-updater to be installed
  // For now, acts as no-op until Capgo is configured

  async checkForUpdate(): Promise<UpdateInfo | null> {
    // Will be implemented when @capgo/capacitor-updater is installed
    return null;
  }

  async downloadUpdate(): Promise<boolean> {
    return false;
  }

  async installUpdate(): Promise<void> {
    // Will reload WebView with new bundle
  }

  onUpdateAvailable(): void {
    // Will register Capgo listener when available
  }
}
